export async function signMessage(signer, address) {
  const now = new Date();
  const exp = Math.floor(now.setMinutes(now.getMinutes() + 5) / 1000);
  const msg = {
    address,
    exp,
  };
  const signature = await signer.signMessage(JSON.stringify(msg));
  return { msg, signature };
}

export function truncateAddress(address) {
  if (!address) return null;
  return address.slice(0, 6) + '...' + address.slice(address.length - 4, address.length);
}
